import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "icon-side-menu" }
const _hoisted_3 = { class: "bottom-icon-side-menu" }


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileSidebar',
  props: {
  isOpen: {
    type: Boolean,
    default: false,
  },
},
  emits: ['toggle'],
  setup(__props, { emit: __emit }) {


const props = __props
const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([[props.isOpen && 'is-active'], "mobile-main-sidebar"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _renderSlot(_ctx.$slots, "links", {}, () => [
            _cache[1] || (_cache[1] = _createElementVNode("li", null, [
              _createElementVNode("a", { href: "/" }, [
                _createElementVNode("i", {
                  "aria-hidden": "true",
                  class: "iconify",
                  "data-icon": "feather:activity"
                })
              ])
            ], -1))
          ])
        ]),
        _createElementVNode("ul", _hoisted_3, [
          _renderSlot(_ctx.$slots, "bottom-links")
        ])
      ])
    ], 2),
    (props.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mobile-overlay",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})